// extracted by mini-css-extract-plugin
export default {"prod-file-attachment":"prod-file-attachment","sub-text":"sub-text","attach-files-container":"attach-files-container","jd-vendor":"jd-vendor"};